// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"a6d2f339","564":"26b61e23"}[chunkId] + ".chunk.js";
};